// skupinaColors — farby skupín zamestnancov (ústava 6+11.6)
// ZDROJ PRAVDY: backend/db.js schedule_groups (DB seed) + /api/schedule-groups
// Načítaj raz pri prvom použití (cache), fallback hardcoded zhodný s DB.
import { useEffect, useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'

// Fallback — presné DB seed farby zo schedule_groups (+ extra ktoré v DB nie sú)
export const SKUPINA_COLORS_FALLBACK = {
  // === DB schedule_groups (zdroj pravdy) ===
  'omietkár-vc':       '#22c55e',  // zelená — Omietkári vápenno-cementové
  'omietkar-vc':       '#22c55e',
  'omietkár-sadra':    '#38bdf8',  // svetlomodrá — Omietkári sadrové
  'omietkar-sadra':    '#38bdf8',
  'poteráč':           '#3b82f6',  // modrá — Poterári
  'poterac':           '#3b82f6',
  'hodinovkár':        '#a3a3a3',  // svetlošedá (aby nebola konflikt s office)
  'hodinovkar':        '#a3a3a3',
  'majster':           '#ef4444',  // červená — Majstri (vrátane "technik")
  'technik':           '#ef4444',
  'poterac-cement':    '#f59e0b',  // žltooranžová — Poterári cementové
  'poterár-cement':    '#f59e0b',
  'poterac-anhydrit':  '#f97316',  // oranžová — Poterári anhydrit
  'poterár-anhydrit':  '#f97316',
  'maliar':            '#ec4899',  // ružová — Maliari
  'office':            '#64748b',  // šedá — Office
  'office_manager':    '#64748b',
  'predajňa':          '#14b8a6',  // tyrkysová (aby nebola konflikt so sadrou)
  'predajna':          '#14b8a6',
  'servis':            '#14b8a6',  // = predajňa (alias) — tyrkysová
  'šofer':             '#a78bfa',  // svetlofialová
  'sofer':             '#a78bfa',
  'šofér':             '#a78bfa',
  'driver':            '#a78bfa',
  'bez-skupiny':       '#94a3b8',  // šedohnedá

  // === Extra — NIE sú v schedule_groups ale potrebujeme ich (manažérske roly) ===
  'majiteľ':           '#94a3b8',  // decentná šedá (Mirko: nepotrebuje výrazný príznak)
  'majitel':           '#94a3b8',
  'owner':             '#94a3b8',
  'owner_view':        '#94a3b8',
  'admin':             '#94a3b8',  // decentná šedá (Mirko: management bez výrazného príznaku)
  'účtovníčka':        '#94a3b8',  // decentná šedá
  'uctovnicka':        '#94a3b8',
  'accountant':        '#94a3b8',
}

let _cache = null
let _promise = null

// Asynchrónne načítanie z API + merge nad fallback
export async function loadSkupinaColors() {
  if (_cache) return _cache
  if (!_promise) {
    _promise = fetchAuth('/api/schedule-groups')
      .then(r => r.ok ? r.json() : [])
      .then(rows => {
        const map = { ...SKUPINA_COLORS_FALLBACK }
        ;(rows || []).forEach(g => { if (g && g.id && g.color) map[g.id] = g.color })
        _cache = map
        return map
      })
      .catch(() => {
        _cache = SKUPINA_COLORS_FALLBACK
        return SKUPINA_COLORS_FALLBACK
      })
  }
  return _promise
}

// Synchrónne hľadanie (po načítaní)
export function skupinaColor(category, role, fallback) {
  const map = _cache || SKUPINA_COLORS_FALLBACK
  const k1 = String(category || '').trim()
  const k2 = String(role || '').trim()
  return map[k1] || map[k1.toLowerCase()] || map[k2] || map[k2.toLowerCase()] || fallback
}

// React hook — automaticky načíta pri mount + re-render po načítaní
export function useSkupinaColors() {
  const [, setReady] = useState(!!_cache)
  useEffect(() => {
    if (!_cache) loadSkupinaColors().then(() => setReady(true))
  }, [])
  return skupinaColor
}
